import { render } from "./MMEditBoardMem.vue?vue&type=template&id=611cf168"
import script from "./MMEditBoardMem.vue?vue&type=script&lang=js"
export * from "./MMEditBoardMem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__